module.exports = __webpack_public_path__ + "img/Bg.0d4725ee.png";